export const Stat = ({
  label,
  value,
  className = ""
}: {
  label: string;
  value: string | number;
  className?: string;
}) => {
  return (
    <div className={className}>
      <h3 className="mb-2 text-xs text-content-400">{label}</h3>
      <p className="text-sm text-content-1000 font-medium truncate">{value}</p>
    </div>
  );
};
